<div class="dialog-padding">
  <h1 mat-dialog-title>
    <ng-container *ngIf="data.svgIcon; else defaultIcon">
      <mat-icon [svgIcon]="data.svgIcon" [class]="data.svgClass"></mat-icon>
    </ng-container>
    <ng-template #defaultIcon>
      <mat-icon class="material-icons-two-tone">help</mat-icon>
    </ng-template>
    <span id="confirmationDialog-text-title">{{ data.title }}</span>
  </h1>
  <p id="confirmationDialog-text-message" mat-dialog-content [innerHTML]="data.message" data-private></p>
  <div mat-dialog-actions align="end">
    <button id="confirmationDialog-button-cancel" mat-button (click)="onNoClick()">{{ data.dismissText }}</button>
    <button
      id="confirmationDialog-button-confirm"
      mat-raised-button
      color="primary"
      uzDebounceClick
      [debounceTime]="500"
      (debounceClick)="confirm()"
    >
      {{ data.confirmText }}
    </button>
  </div>
</div>
